import React, { useContext, useEffect, useState } from "react"
import { Context as AuthContext } from '../contexts/AuthContext'
import { FullPageLoader } from '../components'
import NoticePage from '../pages/NoticePage'

const MagicRedirect = ({}) => {
  const { state: authState } = useContext(AuthContext)
  const [groupId, setGroupId] = useState(null);

  useEffect(() => {
    if (authState.lineContext !== null) {
      let context = authState.lineContext
      let identifier = null

      if (context.type === 'group') {
        identifier = context.groupId
      }

      if (context.type === 'room') {
        identifier = context.roomId
      }

      if (context.type === 'utou') {
        identifier = context.userId
      }

      authState.api.getGroupByLineId(identifier)
        .then((res) => {
          setGroupId(res.data.id)
        })
        .catch((err) => {
        });
    }
  }, [authState.lineContext, authState.api])

  if (groupId) {
    let redirectPath = `https://liff.line.me/${process.env.REACT_APP_LINE_LIFF_ID}/groups/${groupId}/current_overview`
    window.location = redirectPath
  }

  if (authState.lineContext && authState.lineContext.type === 'external') {
    return <NoticePage text="請在手機操作，謝謝！"/>
  } else {
    return <FullPageLoader />
  }
}

export default MagicRedirect